import { FC, memo, ReactNode } from "react";

import { Size, Color, colorToClasses } from "@/components/atoms/buttons/Button";

const sizeToClass = (s?: Size): string => {
  switch (s) {
    case "sm":
      return "md:h-[32px] md:rounded md:px-4";
    case "lg-fix":
      return "md:h-[47px] md:w-full md:px-3 md:rounded-lg";
    case "lg":
      return "md:h-[47px] md:px-4 md:rounded-lg";
    case "md-fix":
      return "md:w-full md:h-10 md:rounded";
    case "md":
    default:
      return "md:h-[44px] md:w-auto md:py-[] md:px-4 md:rounded";
  }
};

const sizeToSPClass = (s?: Size): string => {
  switch (s) {
    case "sm":
      return "h-[32px] rounded px-4";
    case "lg-fix":
      return "h-[47px] w-full px-6 rounded-lg";
    case "lg":
      return "h-[47px] px-6 rounded-lg";
    case "md-fix":
      return "w-full h-10 rounded";
    case "md":
    default:
      return "h-10 px-4 rounded";
  }
};

interface Props {
  label: string;
  icon: JSX.Element;
  className?: string;
  onClick?: (e: React.MouseEvent) => void | Promise<void>;
  disabled?: boolean;
  color?: Color;
  size?: Size;
  spSize?: Size;
  children?: ReactNode;
}

const ButtonWithIconBase: FC<Props> = ({
  label,
  icon,
  className,
  onClick,
  disabled = false,
  size,
  spSize,
  color,
  children,
}) => {
  const sizeClass = sizeToClass(size);
  const sizeSpClass = sizeToSPClass(spSize ?? size);
  const colorClasses = colorToClasses(color);
  const classNames = [
    className,
    "inline-flex items-center justify-center transition md:text-sm md:font-bold button disabled:pointer-events-none gap-x-1 disabled:bg-[#F7F7F7] disabled:text-[#BCBCBC]",
    sizeSpClass,
    sizeClass,
    colorClasses,
  ].join(" ");

  return (
    <>
      <button
        type="button"
        className={classNames}
        onClick={onClick}
        disabled={disabled}
      >
        {icon}
        {label}
        {children}
      </button>
    </>
  );
};

export const ButtonWithIcon = memo(ButtonWithIconBase);
